/**
 * @file transactionErrors.js
 * @brief Maps backend transaction validation errors to localized frontend translation keys.
 */
export function getTransactionErrorMessage(t, error, fallbackKey = "transactionErrors.default") {
    const data = error?.response?.data;

    const code = Array.isArray(data?.code) ? data.code[0] : data?.code;
    const codeMap = {
        cannot_buy_own_listing: "transactionErrors.cannotBuyOwnListing",
        listing_unavailable_for_transaction: "transactionErrors.listingUnavailable",
        transaction_already_in_progress: "transactionErrors.transactionAlreadyInProgress",
        only_seller_can_respond: "transactionErrors.onlySellerCanRespond",
        only_pending_can_be_responded: "transactionErrors.onlyPendingCanBeResponded",
        invalid_decision: "transactionErrors.invalidDecision",
        transaction_no_longer_pending: "transactionErrors.transactionNoLongerPending",
        listing_no_longer_available_for_accept: "transactionErrors.listingNoLongerAvailableForAccept",
        another_transaction_already_active: "transactionErrors.anotherTransactionAlreadyActive",
        only_buyer_can_confirm: "transactionErrors.onlyBuyerCanConfirm",
        only_accepted_can_complete: "transactionErrors.onlyAcceptedCanComplete",
        transaction_no_longer_active: "transactionErrors.transactionNoLongerActive",
    };

    if (typeof code === "string" && codeMap[code]) {
        return t(codeMap[code]);
    }

    const offeredPriceError = Array.isArray(data?.offered_price)
        ? data.offered_price[0]
        : data?.offered_price;

    if (typeof offeredPriceError === "string") {
        if (offeredPriceError.includes("required")) {
            return t("transactionErrors.offerPriceRequired");
        }
        if (offeredPriceError.includes("greater than 0")) {
            return t("transactionErrors.offerPricePositive");
        }
        if (offeredPriceError.includes("Do not set")) {
            return t("transactionErrors.buyShouldNotIncludeOffer");
        }
    }

    const detail = typeof data?.detail === "string" ? data.detail : "";

    const detailMap = {
        "You cannot start a transaction on your own listing.": "transactionErrors.cannotBuyOwnListing",
        "This listing is not available for transaction requests.": "transactionErrors.listingUnavailable",
        "A transaction is already in progress for this listing.": "transactionErrors.transactionAlreadyInProgress",
        "Only the seller can respond to this transaction.": "transactionErrors.onlySellerCanRespond",
        "Only pending transactions can be responded to.": "transactionErrors.onlyPendingCanBeResponded",
        "This transaction is no longer pending.": "transactionErrors.transactionNoLongerPending",
        "Listing is no longer available for accepting a transaction.": "transactionErrors.listingNoLongerAvailableForAccept",
        "Another transaction is already active for this listing.": "transactionErrors.anotherTransactionAlreadyActive",
        "Only the buyer can confirm transaction completion.": "transactionErrors.onlyBuyerCanConfirm",
        "Only accepted transactions can be completed.": "transactionErrors.onlyAcceptedCanComplete",
        "This transaction is no longer active.": "transactionErrors.transactionNoLongerActive",
    };

    if (detailMap[detail]) {
        return t(detailMap[detail]);
    }

    const decisionError = Array.isArray(data?.decision) ? data.decision[0] : data?.decision;
    if (typeof decisionError === "string" && decisionError.includes("accept") && decisionError.includes("refuse")) {
        return t("transactionErrors.invalidDecision");
    }

    return t(fallbackKey);
}
